import React, { FunctionComponent } from 'react'
import { Box } from '@material-ui/core'
import Toolbar from './partials/Toolbar'
import List from './partials/List'
import { SubscriptionsProvider } from './SubscriptionsProvider'
import Message, { MessageProvider } from 'components/elements/Message'

type Props = {}
type Functions = {}
type AllProps = Props & Functions

const Subscriptions: FunctionComponent<AllProps> = ({}) => {
  return (
    <Box p={1.5}>
      <SubscriptionsProvider>
        <MessageProvider>
          <Toolbar />
          <List />
          <Message />
        </MessageProvider>
      </SubscriptionsProvider>
    </Box>
  )
}

export default Subscriptions
